import gql from 'graphql-tag';

export const getGoogleCalendarSyncStatus = gql`
  query getGoogleCalendarSyncStatus($session: String!) {
    getGoogleCalendarSyncStatus(session: $session) {
      status
    }
  }
`;

export const getGoogleCalendarConsentContexts = gql`
  query getGoogleCalendarConsentContexts($session: String!) {
    getGoogleCalendarConsentContexts(session: $session) {
      email
      contexts {
        optionId
        condominium
        unity
        isCurrent
      }
    }
  }
`;
